<template>
  <Transition name="filter-price-shimmer">
    <div
      v-if="isLoading"
      class="filter-price-shimmer"
      aria-busy="true"
      aria-live="polite"
    >
      <div class="filter-price-shimmer__band" />
    </div>
  </Transition>
</template>

<script setup lang="ts">
  interface Props {
    isLoading: boolean;
  }

  defineProps<Props>();
</script>

<style scoped lang="scss">
  $shimmer-cycle-duration: 1200ms; // 400ms движение + 800ms пауза
  $shimmer-move-end: 33.333%; // 400 / 1200
  $shimmer-band-width: 55%;
  $shimmer-z-index: 2;

  .filter-price-shimmer {
    position: absolute;
    inset: 0;
    z-index: $shimmer-z-index;
    overflow: hidden;
    pointer-events: all;
  }

  .filter-price-shimmer__band {
    position: absolute;
    top: 0;
    bottom: 0;
    left: -$shimmer-band-width;
    width: $shimmer-band-width;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.5) 28%,
      rgba(255, 255, 255, 1) 50%,
      rgba(255, 255, 255, 0.5) 72%,
      rgba(255, 255, 255, 0) 100%
    );
    filter: blur(1.5px);
    animation: filter-price-shimmer $shimmer-cycle-duration linear infinite;
  }

  .filter-price-shimmer-enter-active,
  .filter-price-shimmer-leave-active {
    transition: opacity 0.15s ease;
  }

  .filter-price-shimmer-enter-from,
  .filter-price-shimmer-leave-to {
    opacity: 0;
  }

  @keyframes filter-price-shimmer {
    0% {
      left: -$shimmer-band-width;
    }

    #{$shimmer-move-end} {
      left: 100%;
    }

    100% {
      left: 100%;
    }
  }
</style>
